import actions from './actions';

const initState = {
  errorMessage: null,

  reconciliationMIDSettingsLoading: false,
  reconciliationMIDSettings: null,
  reconciliationMIDSettingsIsError: false,
  reconciliationMIDSettingsPagination: null,

  // [FETCH] Payment Channel Report
  paymentChannelReportData: null,
  paymentChannelReportLoading: false,
  paymentChannelReportIsError: false,
  paymentChannelReportFilter: null,
  paymentChannelReportPagination: null,

  // [FETCH] Report Files
  fileReportData: null,
  fileReportLoading: false,
  fileReportIsError: false,

  pchannelRecord: null,
  pchannelRecordLoading: false,
  pchannelRecordIsError: false,
  pchannelRecordFilter: null,
  pchannelRecordPagination: null,
  pchannelRecordSummary: null,

  floatingRecord: null,
  floatingRecordLoading: false,
  floatingRecordIsError: false,
  floatingRecordFilter: null,
  floatingRecordPagination: null,

  resourceRecord: null,
  resourceRecordLoading: false,
  resourceRecordIsError: false,
  resourceRecordFilter: null,
  resourceRecordPagination: null,
  resourceRecordSummary: null,

  hasL2DependencyRecord: null,
  hasL2DependencyRecordIsError: false,
  hasL2DependencyRecordLoading: false,
  hasL2DependencyRecordFilter: null,

  reconFileUploadLoading: false,
  reconFileUploadIsError: false,
  reconFileUploadMessage: null,

  reconFiles: null,
  reconFilesLoading: false,
  reconFilesIsError: false,
  reconFilesFilter: null,
  reconFilesPagination: null,

  reportFiles: null,
  reportFilesLoading: false,
  reportFilesIsError: false,
  reportFilesFilter: null,
  reportFilesPagination: null,

  possibleMatchInSameDateList: null,
  possibleMatchInDiffStatusDate: null,
  possibleMatchInSpecificSearch: null,
  possibleMatchListError: false,
  possibleMatchListLoading: false,
  possibleMatchListFilter: null,
  matchManualTrxLoading: false,
  matchManualTrxError: false,
  ammendTrxLoading: false,
  ammendTrxError: false,
  manualReconcileTrxLoading: false,
  manualReconcileTrxError: false,

  reconReportFileLoading: false,
  reconReportFile: null,
  reconReportFileIsError: false,

  fileLoading: false,
  isFileError: false,

  uploadedFilesRemittanceLoading: false,
  uploadedFilesRemittance: null,
  uploadedFilesRemittanceIsError: false,
  uploadedChannel: null,
  uploadedFilesRemittancePagination: null,

  // [FETCH] Remittance Template with their respective Pchannel
  pchannelRemittanceTemplateData: null,
  pchannelRemittanceTemplateDataLoading: false,
  pchannelRemittanceTemplateDataHasError: false,

  //[FETCH] Remittance Uploaded Data via Payment Channel
  pchannelRemittanceUploadedData: null,
  pchannelRemittanceUploadedDataLoading: false,
  pchannelRemittanceUploadedDataHasError: false,
  pchannelRemittanceUploadedDataPagination: null,
  pchannelRemittanceUploadedDataFilter: null,

  //[FETCH] Remittance Logs via Payment Channel
  pchannelRemittanceLogs: null,
  pchannelRemittanceLogsLoading: false,
  pchannelRemittanceLogsHasError: false,
  pchannelRemittanceLogsPagination: null,
  pchannelRemittanceFilter: null,

  //[FETCH] Remittance Dashboard Data
  financeDashboardPchannelData: null,
  financeDashboardPchannelDataLoading: false,
  financeDashboardPchannelDataHasError: false,
  financeDashboardPchannelDataPagination: null,
  financeDashboardPchannelDataFilter: null,

  deleteRemittanceFileAndTransactionsIsLoading: false,
  deleteRemittanceFileAndTransactionsIsError: false,

  settlementSummaryReportLoading: false,
  settlementSummaryReportIsError: false,

  isDownloadingSettlementSummaryReportFile: false,
  isDownloadingSettlementSummaryReportFileError: null,

  settlementSummaryReportDataLoading: false,
  settlementSummaryReportFileData: null,
  settlementSummaryReportFileDataIsError: false,
  settlementSummaryReportFileDataPagination: false,
  settlementSummaryReportFileDataFilter: null,

  summaryBreakdownReportRemittanceLoading: false,
  summaryBreakdownReportRemittanceIsError: false,

  allGeneratedRemittanceSummaryReportDataLoading: false,
  allGeneratedRemittanceSummaryReportFileData: null,
  allGeneratedRemittanceSummaryReportFileDataIsError: false,
  allGeneratedRemittanceSummaryReportFileDataPagination: false,

  isDownloadingRemittanceSummaryReportFile: false,
  isDownloadingRemittanceSummaryReportFileError: null,

  isDownloadingUploadedFileRemittance: false,
  isDownloadUploadedFileRemittanceError: false,

  // [FETCH] Generated Payment Channel Discrepancy Report And Bank Transactions
  pChannelRemittanceDiscrepancyReportDataAndBankTransactions: null,
  pChannelRemittanceDiscrepancyReportDataAndBankTransactionsLoading: false,
  pChannelRemittanceDiscrepancyReportDataAndBankTransactionsIsError: false,
  pChannelRemittanceDiscrepancyReportDataAndBankTransactionsPagination: null,
  pChannelRemittanceDiscrepancyReportDataAndBankTransactionsFilter: null,

  // [GENERATE] Payment Channel Remittance Discrepancy Report Data
  generatingPaymentChannelRemittanceDiscrepancyReportData: false,
  generatingPaymentChannelRemittanceDiscrepancyReportDataIsError: false,

  generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileLoading: false,
  generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileIsError: false,

  remittanceDiscrepancyTabMessage: null,

  isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile: false,
  isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileError: false,

  allGeneratedPaymentChannelRemittanceBreakdownReportFileDataLoading: false,
  allGeneratedPaymentChannelRemittanceBreakdownReportFileData: null,
  allGeneratedPaymentChannelRemittanceBreakdownReportFileDataIsError: false,
  allGeneratedPaymentChannelRemittanceBreakdownReportFileDataPagination: null,

  rollingReservesLoading: false,
  rollingReserves: null,
  rollingReservesIsError: false,
  rollingReservesFilter: null,
  rollingReservesPagination: null,

  unmatchedTrxLoading: false,
  unmatchedTrx: null,
  unmatchedTrxTotal: null,
  unmatchedTrxSummary: null,
  unmatchedTrxSettings: null,
  unmatchedTrxIsError: false,
  unmatchedTrxFilter: null,
  unmatchedTrxPagination: null,

  activeUnmatchedTrx: null,
  activeUnmatchedTrxLoading: false,

  unmatchedTrxLogsData: null,
  unmatchedTrxLogsLoading: false,
  unmatchedTrxLogsisError: false,
  unmatchedTrxLogsPagination: null,
  unmatchedTrxLogsFilter: null,
  unmatchedTrxLogsLoadmore: false,

  updatedTrxData: null,
  updatedTrxLoading: false,
  updatedTrxIsError: false,
  updatedTrxPagination: null,
  updatedTrxFilter: null,

  notifyMerchantIsError: false,
  notifyMerchantLoading: false,

  unmatchedTrxDetails: null,
  fetchingTrxDetails: false,

  assignedApprovers: null,
  assignedApproversLoading: false,
  assignedApproversIsError: false,

  manageApproverDepartmentsLoading: false,
  manageApproverDepartmentsIsError: false,

  exceptionTrxData: null,
  exceptionTrxLoading: false,
  exceptionTrxIsError: false,
  exceptionTrxPagination: null,
  exceptionTrxFilter: null,
  exceptionTrxTotal: null,
  exceptionTrxSummary: null,

  checkingFilteredRemittanceTransactionsLoading: false,
  checkingFilteredRemittanceTransactionsIsError: false,

  tagFilteredRemittanceTransactionsLoading: false,
  tagFilteredRemittanceTransactionsIsError: false,

  updatingReconciliationRemittanceStatus: false,
  updatingReconciliationRemittanceStatusIsError: false,

  updateResourceTransactionRemittanceStatus: false,
  updateResourceTransactionRemittanceStatusIsError: false,

  remittanceActionMessage: null,
  remittanceActionIsError: false,
  remittanceActionNotifierMessage: null,
  remittanceActionNotifierIsSuccess: false,

  bankTemplateByPChannel: [],
  bankTemplateByPChannelCache: [],
  bankTemplateByPChannelLoading: false,

  // allGeneratedRemittanceSummaryReportFileData: null
  generatedRemittanceReconciliationReportFileData: null,
  generatedRemittanceReconciliationReportFileDataIsLoading: false,
  generatedRemittanceReconciliationReportFileDataPagination: null,
  generatedRemittanceReconciliationReportFileDataIsError: false,
  generatedRemittanceReconciliationReportFileDataCache: {}
};

export default (state = initState, action) => {
  // if (action.type !== 'RESET_SECOND_TIMER') // console.log('REDUCER TRIGGERED', action)

  switch (action.type) {
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        paymentChannelReportLoading: false,
        reconFileUploadIsError: false,
        reconFileUploadMessage: null,
        reconFilesIsError: false,
        reportFilesIsError: false
      };

    case actions.ADDING_RECONCILIATION_MID_SETTING:
      return {
        ...state,
        reconciliationMIDSettingsLoading: true,
        isError: false
      };

    case actions.ADD_RECONCILIATION_MID_SETTING_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        reconciliationMIDSettingsLoading: false,
        reconciliationMIDSettings: [
          action?.result ?? [],
          ...(state?.reconciliationMIDSettings ?? [])
        ]
      };

    case actions.ADD_RECONCILIATION_MID_SETTING_FAILED:
      return {
        ...state,
        reconciliationMIDSettingsLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_RECONCILIATION_MID_SETTINGS:
      return {
        ...state,
        reconciliationMIDSettingsLoading: true
      };

    case actions.FETCH_RECONCILIATION_MID_SETTINGS_SUCCESS:
      return {
        ...state,
        reconciliationMIDSettingsLoading: false,
        reconciliationMIDSettings: action.result,
        reconciliationMIDSettingsIsError: false,
        reconciliationMIDSettingsPagination: action.pagination
      };

    case actions.FETCH_RECONCILIATION_MID_SETTINGS_FAILED:
      return {
        ...state,
        reconciliationMIDSettingsLoading: false,
        reconciliationMIDSettingsIsError: true,
        reconciliationMIDSettingsPagination: action.pagination
      };

    case actions.UPDATING_RECONCILIATION_MID_SETTING:
      return {
        ...state,
        isError: false,
        reconciliationMIDSettingsLoading: true
      };

    case actions.UPDATE_RECONCILIATION_MID_SETTING_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        reconciliationMIDSettingsLoading: false,
        errorMessage: action.message,
        isError: false,
        reconciliationMIDSettings:
          state.reconciliationMIDSettings?.map(item => {
            if (item.id === action.result.id) {
              return { ...item, ...(action?.result ?? {}) };
            }
            return item;
          }) || []
      };

    case actions.UPDATE_RECONCILIATION_MID_SETTING_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        reconciliationMIDSettingsLoading: false
      };

    case actions.FETCHING_PAYMENT_CHANNEL_REPORTS:
      return {
        ...state,
        paymentChannelReportLoading: true
      };
    case actions.FETCH_PAYMENT_CHANNEL_REPORTS_SUCCESS:
      return {
        ...state,
        paymentChannelReportData: action.payload,
        paymentChannelReportIsError: false,
        paymentChannelReportLoading: action.loading,
        paymentChannelReportFilter: action.filter,
        paymentChannelReportPagination: action.pagination
      };
    case actions.FETCH_PAYMENT_CHANNEL_REPORTS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        paymentChannelReportIsError: false,
        paymentChannelReportLoading: action.loading,
        paymentChannelReportFilter: action.filter,
        paymentChannelReportPagination: action.pagination
      };

    case actions.RESET_PAYMENT_CHANNEL_REPORTS:
      return {
        ...state,
        errorMessage: null,
        paymentChannelReportData: null,
        paymentChannelReportIsError: false,
        paymentChannelReportFilter: null,
        paymentChannelReportPagination: null
      };

    case actions.FETCHING_PAYMENT_CHANNEL_RECORDS:
      return {
        ...state,
        pchannelRecordLoading: true
      };
    case actions.FETCH_PAYMENT_CHANNEL_RECORDS_SUCCESS:
      return {
        ...state,
        pchannelRecord: action.payload,
        pchannelRecordIsError: false,
        pchannelRecordLoading: action.loading,
        pchannelRecordFilter: action.filter,
        pchannelRecordPagination: action.pagination,
        pchannelRecordSummary: action.summary
      };
    case actions.FETCH_PAYMENT_CHANNEL_RECORDS_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        pchannelRecord: action.payload,
        pchannelRecordIsError: true,
        pchannelRecordLoading: false,
        pchannelRecordFilter: action.filter,
        pchannelRecordPagination: action.pagination,
        pchannelRecordSummary: null
      };

    case actions.RESET_PAYMENT_CHANNEL_RECORDS:
      return {
        ...state,
        errorMessage: null,
        pchannelRecord: null,
        pchannelRecordPagination: null,
        pchannelRecordSummary: null
      };

    case actions.FETCHING_FLOATING_RECORDS:
      return {
        ...state,
        floatingRecordLoading: true
      };
    case actions.FETCH_FLOATING_RECORDS_SUCCESS:
      return {
        ...state,
        floatingRecord: action.payload,
        floatingRecordIsError: false,
        floatingRecordLoading: action.loading,
        floatingRecordFilter: action.filter,
        floatingRecordPagination: action.pagination
      };
    case actions.FETCH_FLOATING_RECORDS_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        floatingRecord: action.payload,
        floatingRecordIsError: true,
        floatingRecordLoading: false,
        floatingRecordFilter: action.filter,
        floatingRecordPagination: action.pagination
      };

    case actions.RESET_FLOATING_RECORDS:
      return {
        ...state,
        errorMessage: null,
        floatingRecord: null,
        floatingRecordLoading: false,
        floatingRecordPagination: null
      };

    case actions.FETCHING_POSSIBLE_MATCH_LIST:
      return {
        ...state,
        possibleMatchListLoading: true
      };
    case actions.FETCH_POSSIBLE_MATCH_LIST_SUCCESS:
      let finalList = action.payload ? action.payload : [];
      return {
        ...state,
        possibleMatchInSameDateList: finalList.filter(
          item => item.status === 'FOUND_FROM_SAME_DATE_SUCCESS'
        ),
        possibleMatchInDiffStatusDate: finalList.filter(
          item =>
            item.status === 'FOUND_FROM_SAME_DATE_OTHER_STATUS' ||
            item.status === 'FOUND_FROM_OTHER_DATE'
        ),
        possibleMatchInSpecificSearch: finalList.filter(
          item => item.status === 'FOUND_FROM_SPECIFIC_TRX'
        ),
        possibleMatchListError: false,
        possibleMatchListLoading: action.loading,
        possibleMatchListFilter: action.filter
      };
    case actions.FETCH_POSSIBLE_MATCH_LIST_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        possibleMatchInSameDateList: null,
        possibleMatchInDiffStatusDate: null,
        possibleMatchInSpecificSearch: null,
        possibleMatchListError: true,
        possibleMatchListLoading: false,
        possibleMatchListFilter: action.filter
      };

    case actions.RESET_POSSIBLE_MATCH_LIST:
      return {
        ...state,
        errorMessage: null,
        possibleMatchInSameDateList: null,
        possibleMatchInSameDateListOtherStatus: null,
        possibleMatchInSpecificSearch: null,
        possibleMatchListFilter: null,
        possibleMatchListError: false
      };

    case actions.MATCHING_MANUAL_TRX:
      return {
        ...state,
        matchManualTrxLoading: true
      };
    case actions.MATCH_MANUAL_TRX_SUCCESS:
      return {
        ...state,
        matchManualTrxLoading: false,
        matchManualTrxError: false,
        reconFileUploadIsError: false,
        ammendTrxError: false,
        reconFileUploadMessage: action.message
      };
    case actions.MATCH_MANUAL_TRX_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        matchManualTrxLoading: false,
        matchManualTrxError: true,
        ammendTrxError: true,
        reconFileUploadIsError: true,
        reconFileUploadMessage: action.message
      };

    case actions.MANUAL_RECONCILE_TRX_LOADING:
      return {
        ...state,
        matchManualTrxLoading: true
      };
    case actions.MANUAL_RECONCILE_TRX_SUCCESS:
      return {
        ...state,
        matchManualTrxLoading: false,
        isError: false,
        errorMessage: action.message
      };
    case actions.MANUAL_RECONCILE_TRX_FAILED:
      return {
        ...state,
        matchManualTrxLoading: false,
        isError: true,
        errorMessage: action.message

      };

    case actions.AMMENDING_MANUAL_TRX:
      return {
        ...state,
        ammendTrxLoading: true
      };
    case actions.AMMEND_MANUAL_TRX_SUCCESS:
      return {
        ...state,
        ammendTrxLoading: false,
        ammendTrxError: false,
        reconFileUploadMessage: action.message
      };
    case actions.AMMEND_MANUAL_TRX_FAILED:
      return {
        ...state,
        reconFileUploadMessage: action.message,
        ammendTrxLoading: false,
        ammendTrxError: true
      };

    case actions.FETCHING_RECON_FILES:
      return {
        ...state,
        reconFilesLoading: true
      };
    case actions.FETCH_RECON_FILES_SUCCESS:
      return {
        ...state,
        reconFiles: action.payload,
        reconFilesIsError: false,
        reconFilesLoading: action.loading,
        reconFilesFilter: action.filter,
        reconFilesPagination: action.pagination
      };
    case actions.FETCH_RECON_FILES_FAILED:
      return {
        ...state,
        reconFiles: action.payload,
        reconFilesIsError: true,
        reconFilesLoading: false,
        reconFilesFilter: action.filter,
        reconFilesPagination: action.pagination
      };

    case actions.FETCHING_REPORT_FILES:
      return {
        ...state,
        reportFilesLoading: true
      };
    case actions.FETCH_REPORT_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        reportFiles: action.payload,
        reportFilesIsError: false,
        reportFilesLoading: action.loading,
        reportFilesFilter: action.filter,
        reportFilesPagination: action.pagination
      };
    case actions.FETCH_REPORT_FILES_FAILED:
      return {
        ...state,
        reportFiles: action.payload,
        reportFilesIsError: true,
        reportFilesLoading: false,
        reportFilesFilter: action.filter,
        reportFilesPagination: action.pagination
      };

    case actions.PROCESSING_RECON_FILE_ACTION:
      return {
        ...state,
        reconFilesLoading: true
      };
    case actions.PROCESS_RECON_FILE_ACTION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        reconFilesIsError: false,
        reconFilesLoading: action.loading
      };
    case actions.PROCESS_RECON_FILE_ACTION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        reconFilesIsError: true,
        reconFilesLoading: false
      };

    case actions.RESET_RECON_FILES:
      return {
        ...state,
        errorMessage: null,
        reconFiles: null,
        reconFilesPagination: null
      };

    case actions.RESET_REPORT_FILES:
      return {
        ...state,
        errorMessage: null,
        reportFiles: null,
        reportFilesPagination: null
      };

    case actions.FETCHING_RESOURCE_RECORDS:
      return {
        ...state,
        resourceRecordLoading: true
      };
    case actions.FETCH_RESOURCE_RECORDS_SUCCESS:
      return {
        ...state,
        // errorMessage: action.message,
        resourceRecord: action.payload,
        resourceRecordIsError: false,
        resourceRecordLoading: action.loading,
        resourceRecordFilter: action.filter,
        resourceRecordPagination: action.pagination,
        resourceRecordSummary: action.summary
      };
    case actions.FETCH_RESOURCE_RECORDS_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        resourceRecord: action.payload,
        resourceRecordIsError: true,
        resourceRecordLoading: false,
        resourceRecordFilter: action.filter,
        resourceRecordPagination: action.pagination,
        resourceRecordSummary: null
      };

    case actions.RESET_RESOURCE_RECORDS:
      return {
        ...state,
        errorMessage: null,
        resourceRecord: null,
        resourceRecordPagination: null,
        resourceRecordSummary: null
      };

    case actions.FETCHING_HAS_L2_DEPENDENCY_RECORDS:
      return {
        ...state,
        hasL2DependencyRecordLoading: true
      };
    case actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_SUCCESS:
      return {
        ...state,
        hasL2DependencyRecord: action.payload,
        hasL2DependencyRecordIsError: false,
        hasL2DependencyRecordLoading: action.loading,
        hasL2DependencyRecordFilter: action.filter
      };
    case actions.FETCH_HAS_L2_DEPENDENCY_RECORDS_FAILED:
      return {
        ...state,
        // errorMessage: action.message,
        hasL2DependencyRecordIsError: true,
        hasL2DependencyRecordLoading: false,
        hasL2DependencyRecordFilter: action.filter
      };

    case actions.UPLOADING_RECON_FILE:
      return {
        ...state,
        reconFileUploadLoading: true
      };

    case actions.UPLOAD_RECON_FILE_SUCCESS:
      return {
        ...state,
        reconFileUploadLoading: true,
        reconFileUploadIsError: false,
        reconFileUploadMessage: action.message
      };
    case actions.UPLOAD_RECON_FILE_FAILED:
      return {
        ...state,
        reconFileUploadLoading: false,
        reconFileUploadIsError: true,
        reconFileUploadMessage: action.message
      };

    case actions.GENERATING_RECON_REPORT:
      return {
        ...state,
        reconReportFile: null,
        reconReportFileLoading: true
      };

    case actions.GENERATE_RECON_REPORT_SUCCESS:
      return {
        ...state,
        reconReportFileLoading: false,
        reconReportFile: action.result,
        reconReportFileIsError: false,
        errorMessage: action.message
      };

    case actions.GENERATE_RECON_REPORT_FAILED:
      return {
        ...state,
        reconReportFileLoading: false,
        reconReportFile: action.result,
        reconReportFileIsError: true,
        errorMessage: action.message
      };

    case actions.STORE_PENDING_RECON_REPORT_DATA:
      return {
        ...state,
        reconReportFile: action.payload
      };

    case actions.DOWNLOADING_RECONCILIATION_REPORT_DATA:
      return {
        ...state,
        reconciliationReportLoading: true
      };

    case actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_SUCCESS:
      return {
        ...state,
        reconciliationReportLoading: false,
        reconciliationReportIsError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_RECONCILIATION_REPORT_DATA_FAILED:
      return {
        ...state,
        reconciliationReportLoading: false,
        reconciliationReportIsError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_FILE_FROM_PCHANNEL_REPORTS:
      return {
        ...state,
        fileReportLoading: true
      };
    case actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        fileReportData: action.payload,
        fileReportIsError: false,
        fileReportLoading: action.loading
      };
    case actions.FETCH_FILE_FROM_PCHANNEL_REPORTS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        fileReportIsError: true,
        fileReportLoading: action.loading
      };

    case actions.RESET_FILE_FROM_PCHANNEL_REPORTS:
      return {
        ...state,
        errorMessage: null,
        fileReportData: null,
        fileReportIsError: false,
        fileReportLoading: false
      };

    // REMITTANCE
    case actions.FETCHING_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCCESS:
      return {
        ...state,
        pchannelRemittanceTemplateData: action.result,
        pchannelRemittanceTemplateDataHasError: false,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.FETCH_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
      return {
        ...state,
        pchannelRemittanceTemplateDataHasError: true,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.RESET_ALL_REMITTANCE_TEMPLATE_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceTemplateData: null,
        pchannelRemittanceTemplateDataHasError: false
      };
    case actions.ADDING_REMITTANCE_TEMPLATE_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateDataHasError: false
      };
    case actions.ADD_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.EDITING_REMITTANCE_TEMPLATE_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateDataHasError: false
      };
    case actions.EDIT_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.TOGGLING_REMITTANCE_TEMPLATE_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };
    case actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateDataHasError: false
      };
    case actions.TOGGLE_REMITTANCE_TEMPLATE_FROM_PCHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true,
        pchannelRemittanceTemplateDataLoading: action.loading
      };

    case actions.UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE:
      return {
        ...state,
        fileLoading: true,
        isFileError: false,
        pageLoading: true
      };

    case actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_REMITTANCE_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        isFileError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.FETCHING_UPLOADED_FILES_REMITTANCE:
      return {
        ...state,
        uploadedFilesRemittance: null,
        pageLoading: action.loading,
        uploadedFilesRemittanceLoading: action.loading
      };

    case actions.FETCH_UPLOADED_FILES_REMITTANCE_SUCCESS:
      return {
        ...state,
        uploadedFilesRemittanceLoading: action.loading,
        pageLoading: action.loading,
        uploadedFilesRemittance: action.result,
        uploadedChannel: action.channel,
        uploadedFilesRemittanceIsError: false,
        uploadedFilesRemittancePagination: action.pagination
      };

    case actions.FETCH_UPLOADED_FILES_REMITTANCE_FAILED:
      return {
        ...state,
        uploadedFilesRemittanceLoading: action.loading,
        pageLoading: action.loading,
        uploadedFilesRemittance: action.result,
        uploadedChannel: action.channel,
        uploadedFileRemittancesIsError: true,
        uploadedFilesRemittancePagination: action.pagination
      };
    case actions.FETCHING_REMITTANCE_UPLOADED_PCHANNEL_DATA:
      return {
        ...state,
        pchannelRemittanceUploadedDataLoading: action.loading
      };
    case actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_SUCCESS:
      return {
        ...state,
        pchannelRemittanceUploadedDataLoading: action.loading,
        pchannelRemittanceUploadedData: action.result,
        pchannelRemittanceUploadedDataPagination: action.pagination,
        pchannelRemittanceUploadedDataFilter: action.filter,
        pchannelRemittanceUploadedDataHasError: false
      };
    case actions.FETCH_REMITTANCE_UPLOADED_PCHANNEL_DATA_FAILED:
      return {
        ...state,
        pchannelRemittanceUploadedData: action.result,
        pchannelRemittanceUploadedDataHasError: true,
        pchannelRemittanceUploadedDataPagination: action.pagination,
        pchannelRemittanceUploadedDataLoading: action.loading
      };
    case actions.RESET_REMITTANCE_UPLOADED_PCHANNEL_DATA:
      return {
        ...state,
        pchannelRemittanceUploadedDataFilter: null,
        pchannelRemittanceUploadedData: null,
        pchannelRemittanceUploadedDataPagination: null
      };
    case actions.FETCHING_REMITTANCE_LOGS_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceLogsLoading: action.loading
      };
    case actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_SUCCESS:
      return {
        ...state,
        pchannelRemittanceLogs: action.result,
        pchannelRemittanceLogsHasError: false,
        pchannelRemittanceLogsLoading: action.loading,
        pchannelRemittanceLogsPagination: action.pagination,
        pchannelRemittanceFilter: action.filter
      };
    case actions.FETCH_REMITTANCE_LOGS_FROM_PCHANNEL_FAILED:
      return {
        ...state,
        pchannelRemittanceLogs: action.result,
        pchannelRemittanceLogsHasError: false,
        pchannelRemittanceLogsLoading: action.loading,
        pchannelRemittanceLogsPagination: action.pagination
      };
    case actions.RESET_REMITTANCE_LOGS_FROM_PCHANNEL:
      return {
        ...state,
        pchannelRemittanceLogs: null,
        pchannelRemittanceLogsPagination: null
      };
    case actions.FETCHING_FINANCE_DASHBOARD_PCHANNEL_DATA:
      return {
        ...state,
        financeDashboardPchannelDataLoading: true,
        financeDashboardPchannelData: null
      };
    case actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_SUCCESS:
      return {
        ...state,
        financeDashboardPchannelData: action.result,
        financeDashboardPchannelDataHasError: false,
        financeDashboardPchannelDataPagination: action.pagination,
        financeDashboardPchannelDataFilter: action.filter,
        financeDashboardPchannelDataLoading: action.loading
      };
    case actions.FETCH_FINANCE_DASHBOARD_PCHANNEL_DATA_FAILED:
      return {
        ...state,
        financeDashboardPchannelData: action.result,
        financeDashboardPchannelDataHasError: true,
        financeDashboardPchannelDataLoading: action.loading
      };

    case actions.DELETING_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS:
      return {
        ...state,
        deleteRemittanceFileAndTransactionsIsLoading: action.loading
      };

    case actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        deleteRemittanceFileAndTransactionsIsLoading: action.loading,
        deleteRemittanceFileAndTransactionsIsError: false,
        errorMessage: action.message
      };

    case actions.DELETE_UPLOADED_REMITTANCE_FILE_AND_TRANSACTIONS_FAILED:
      return {
        ...state,
        deleteRemittanceFileAndTransactionsIsLoading: action.loading,
        deleteRemittanceFileAndTransactionsIsError: true,
        errorMessage: action.message
      };

    case actions.GENERATING_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        settlementSummaryReportLoading: true,
        settlementSummaryReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        settlementSummaryReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        settlementSummaryReportLoading: action.loading,
        settlementSummaryReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DOWNLOADING_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: true
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingSettlementSummaryReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_SETTLEMENT_SUMMARY_REPORT_DATA:
      return {
        ...state,
        settlementSummaryReportFileData: null,
        settlementSummaryReportDataLoading: action.loading
      };

    case actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        settlementSummaryReportDataLoading: action.loading,
        settlementSummaryReportFileData: action.result,
        settlementSummaryReportFileDataIsError: false,
        settlementSummaryReportFileDataPagination: action.pagination,
        settlementSummaryReportFileDataFilter: action.filter
      };

    case actions.FETCH_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED:
      return {
        ...state,
        settlementSummaryReportDataLoading: action.loading,
        settlementSummaryReportFileData: action.result,
        settlementSummaryReportFileDataIsError: true,
        settlementSummaryReportFileDataPagination: action.pagination
      };

    case actions.REQUESTING_REVIEW_SETTLEMENT_SUMMARY_REPORT:
    case actions.APPROVING_SETTLEMENT_SUMMARY_REPORT:
    case actions.REJECTING_SETTLEMENT_SUMMARY_REPORT:
      return {
        ...state,
        isError: false,
        settlementSummaryReportDataLoading: true
      };

    case actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    case actions.APPROVE_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
    case actions.REJECT_SETTLEMENT_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        settlementSummaryReportDataLoading: false,
        errorMessage: action.message,
        isError: false
      };

    case actions.REQUEST_REVIEW_SETTLEMENT_SUMMARY_REPORT_FAILED:
    case actions.APPROVE_SETTLEMENT_SUMMARY_REPORT_FAILED:
    case actions.REJECT_SETTLEMENT_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        settlementSummaryReportDataLoading: action.loading,
        isError: true
      };

    case actions.GENERATING_SUMMARY_BREAKDOWN_REPORT_REMITTANCE:
      return {
        ...state,
        summaryBreakdownReportRemittanceLoading: true,
        summaryBreakdownReportRemittanceIsError: false,
        pageLoading: true
      };
    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_SUCCESS:
      return {
        ...state,
        summaryBreakdownReportRemittanceIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };
    case actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_REMITTANCE_FAILED:
      return {
        ...state,
        summaryBreakdownReportRemittanceLoading: action.loading,
        summaryBreakdownReportRemittanceIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.FETCHING_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA:
      return {
        ...state,
        allGeneratedRemittanceSummaryReportFileData: null,
        allGeneratedRemittanceSummaryReportDataLoading: action.loading
      };

    case actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        allGeneratedRemittanceSummaryReportDataLoading: action.loading,
        allGeneratedRemittanceSummaryReportFileData: action.result,
        allGeneratedRemittanceSummaryReportFileDataIsError: false,
        allGeneratedRemittanceSummaryReportFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_GENERATED_REMITTANCE_SUMMARY_REPORT_DATA_FAILED:
      return {
        ...state,
        allGeneratedRemittanceSummaryReportDataLoading: action.loading,
        allGeneratedRemittanceSummaryReportFileData: action.result,
        allGeneratedRemittanceSummaryReportFileDataIsError: true,
        allGeneratedRemittanceSummaryReportFileDataPagination: action.pagination
      };

    case actions.DOWNLOADING_REMITTANCE_SUMMARY_REPORT:
      return {
        ...state,
        isDownloadingRemittanceSummaryReportFile: true
      };

    case actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingRemittanceSummaryReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_REMITTANCE_SUMMARY_REPORT_FAILED:
      return {
        ...state,
        isDownloadingRemittanceSummaryReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_UPLOADED_FILE_REMITTANCE:
      return {
        ...state,
        isDownloadingUploadedFileRemittance: true
      };

    case actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_SUCCESS:
      return {
        ...state,
        isDownloadUploadedFileRemittanceError: false,
        isDownloading: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_UPLOADED_FILE_REMITTANCE_FAILED:
      return {
        ...state,
        isDownloadingUploadedFileRemittance: false,
        isDownloadUploadedFileRemittanceError: true,
        errorMessage: action.message
      };
    case actions.FETCHING_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS:
      return {
        ...state,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsLoading: true,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactions: null,
        remittanceDiscrepancyTabMessage: null
      };
    case actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactions: action.result,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsIsError: false,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsPagination: action.pagination,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsFilter: action.filter,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsLoading: action.loading,
        remittanceDiscrepancyTabMessage: action.message
      };
    case actions.FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS_FAILED:
      return {
        ...state,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactions: action.result,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsIsError: true,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsLoading: action.loading,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsPagination: action.pagination,
        remittanceDiscrepancyTabMessage: action.message
      };
    case actions.RESET_FETCH_GENERATED_PAYMENT_CHANNEL_DISCREPANCY_REPORT_AND_BANK_TRANSACTIONS:
      return {
        ...state,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsFilter: null,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactions: null,
        pChannelRemittanceDiscrepancyReportDataAndBankTransactionsPagination: null,
        remittanceDiscrepancyTabMessage: null
      };
    case actions.CLEAR_DISCREPANCY_TAB_MESSAGE:
      return {
        ...state,
        remittanceDiscrepancyTabMessage: null
      };
    case actions.GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyReportData: true,
        generatingPaymentChannelRemittanceDiscrepancyReportDataIsError: false,
        remittanceDiscrepancyTabMessage: null
        // pageLoading: true
      };

    case actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyReportDataIsError: false,
        generatingPaymentChannelRemittanceDiscrepancyReportData: false,
        remittanceDiscrepancyTabMessage: action.message
        // pageLoading: false
      };
    case actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_REPORT_DATA_FAILED:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyReportData: false,
        generatingPaymentChannelRemittanceDiscrepancyReportDataIsError: true,
        remittanceDiscrepancyTabMessage: action.message
        // pageLoading: false
      };
    case actions.GENERATING_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileLoading: true,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileIsError: false
        // pageLoading: true
      };
    case actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileLoading: false,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileIsError: false,
        errorMessage: action.message
        // pageLoading: false
      };
    case actions.GENERATE_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED:
      return {
        ...state,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileLoading: false,
        generatingPaymentChannelRemittanceDiscrepancyBreakdownReportFileIsError: true,
        errorMessage: action.message
        // pageLoading: false
      };
    case actions.DOWNLOADING_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE:
      return {
        ...state,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile: true,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileError: false
      };
    case actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_SUCCESS:
      return {
        ...state,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile: false,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileError: false,
        errorMessage: action.message
      };
    case actions.DOWNLOAD_GENERATED_PAYMENT_CHANNEL_REMITTANCE_DISCREPANCY_BREAKDOWN_REPORT_FILE_FAILED:
      return {
        ...state,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFile: false,
        isDownloadingGeneratedPaymentChannelRemittanceDiscrepancyBreakdownReportFileError: true,
        errorMessage: action.message
      };
    case actions.FETCHING_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA:
      return {
        ...state,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileData: null,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataLoading: action.loading
      };
    case actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_SUCCESS:
      return {
        ...state,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataLoading: action.loading,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileData: action.result,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataIsError: false,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataPagination: action.pagination
      };
    case actions.FETCH_ALL_GENERATED_PAYMENT_CHANNEL_REMITTANCE_BREAKDOWN_REPORT_FILE_DATA_FAILED:
      return {
        ...state,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataLoading: action.loading,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileData: action.result,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataIsError: true,
        allGeneratedPaymentChannelRemittanceBreakdownReportFileDataPagination: action.pagination
      };
    case actions.FETCHING_ROLLING_RESERVES:
      return {
        ...state,
        rollingReserves: null,
        rollingReservesLoading: true
      };

    case actions.FETCH_ROLLING_RESERVES_SUCCESS:
      return {
        ...state,
        rollingReservesLoading: action.loading,
        rollingReserves: action.result,
        rollingReservesIsError: false,
        rollingReservesFilter: action.filter,
        rollingReservesPagination: action.pagination
      };

    case actions.FETCH_ROLLING_RESERVES_FAILED:
      return {
        ...state,
        rollingReservesLoading: action.loading,
        rollingReserves: action.result,
        rollingReservesIsError: true
      };

    case actions.FETCHING_UNMATCHED_TRX:
      return {
        ...state,
        unmatchedTrx: null,
        unmatchedTrxLoading: true
      };

    case actions.FETCH_UNMATCHED_TRX_SUCCESS:
      return {
        ...state,
        unmatchedTrxLoading: action.loading,
        unmatchedTrx: action.result,
        unmatchedTrxTotal: action.total,
        unmatchedTrxSummary: action.summary,
        unmatchedTrxSettings: action.settings,
        unmatchedTrxIsError: false,
        unmatchedTrxFilter: action.filter,
        unmatchedTrxPagination: action.pagination
      };

    case actions.FETCH_UNMATCHED_TRX_FAILED:
      return {
        ...state,
        unmatchedTrxLoading: action.loading,
        unmatchedTrx: null,
        unmatchedTrxSummary: null,
        unmatchedTrxSettings: null,
        unmatchedTrxTotal: action.total,
        unmatchedTrxIsError: true
      };

    case actions.FETCHING_UNMATCHED_TRX_DETAILS:
      return {
        ...state,
        fetchingTrxDetails: true
      };
    case actions.FETCH_UNMATCHED_TRX_DETAILS_SUCCESS:
      return {
        ...state,
        unmatchedTrxDetails: action.payload,
        fetchingTrxDetails: false,
        unmatchedTrxIsError: false
      };
    case actions.FETCH_UNMATCHED_TRX_DETAILS_FAILED:
      return {
        ...state,
        fetchingTrxDetails: false,
        errorMessage: action.error
      };

    case actions.PROCESSING_UNMATCHED_TRX_REQUEST:
      return {
        ...state,
        unmatchedTrxIsError: false,
        pageLoading: true,
        unmatchedTrxLoading: true
      };

    case actions.PROCESS_UNMATCHED_TRX_REQUEST_SUCCESS:
      return {
        ...state,
        unmatchedTrxLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        unmatchedTrxIsError: false
      };

    case actions.PROCESS_UNMATCHED_TRX_REQUEST_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        unmatchedTrxLoading: action.loading,
        unmatchedTrxIsError: true,
        pageLoading: false
      };

    case actions.ENDORSING_UNMATCHED_TRX:
      return {
        ...state,
        unmatchedTrxIsError: false,
        pageLoading: true,
        unmatchedTrxLoading: true
      };

    case actions.ENDORSE_UNMATCHED_TRX_SUCCESS:
      return {
        ...state,
        unmatchedTrxLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        unmatchedTrxIsError: false
      };

    case actions.ENDORSE_UNMATCHED_TRX_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        unmatchedTrxLoading: action.loading,
        unmatchedTrxIsError: true,
        pageLoading: false
      };

    case actions.UPDATING_UNMATCHED_TRX:
      return {
        ...state,
        unmatchedTrxIsError: false,
        pageLoading: true,
        unmatchedTrxLoading: true
      };

    case actions.UPDATE_UNMATCHED_TRX_SUCCESS:
      return {
        ...state,
        unmatchedTrxLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        unmatchedTrxIsError: false
      };

    case actions.UPDATE_UNMATCHED_TRX_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        unmatchedTrxLoading: action.loading,
        unmatchedTrxIsError: true,
        pageLoading: false
      };
    case actions.FETCHING_UPDATED_TRX:
      return {
        ...state,
        updatedTrxLoading: action.loading,
        updatedTrxData: null
      };

    case actions.FETCH_UPDATED_TRX_SUCCESS:
      return {
        ...state,
        updatedTrxLoading: action.loading,
        updatedTrxData: action.result,
        updatedTrxIsError: false,
        updatedTrxPagination: action.pagination,  
        updatedTrxFilter: action.filter
      };

    case actions.FETCH_UPDATED_TRX_FAILED:
      return {
        ...state,
        updatedTrxLoading: action.loading,
        updatedTrxData: null,
        updatedTrxIsError: true,
        updatedTrxPagination: null,
        updatedTrxFilter: null
      };

      case actions.NOTIFYING_MERCHANT:
      return {
        ...state,
        notifyMerchantIsError: false,
        notifyMerchantLoading: true
      };

    case actions.NOTIFY_MERCHANT_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        notifyMerchantLoading: false,
        notifyMerchantIsError: false
      };

    case actions.NOTIFY_MERCHANT_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        notifyMerchantIsError: true,
        notifyMerchantLoading: false
      };

    case actions.FETCHING_UNMATCHED_TRX_LOGS:
      return {
        ...state,
        unmatchedTrxLogsLoading: action.loading,
        unmatchedTrxLogsData: null
      };

    case actions.FETCH_UNMATCHED_TRX_LOGS_SUCCESS:
      return {
        ...state,
        unmatchedTrxLogsLoading: action.loading,
        unmatchedTrxLogsData: action.result,
        unmatchedTrxLogsisError: false,
        unmatchedTrxLogsPagination: action.pagination,
        unmatchedTrxLogsFilter: action.filter,
      };

    case actions.FETCH_UNMATCHED_TRX_LOGS_FAILED:
      return {
        ...state,
        unmatchedTrxLogsLoading: action.loading,
        unmatchedTrxLogsData: action.result,
        unmatchedTrxLogsisError: true,
        unmatchedTrxLogsPagination: action.pagination,
        unmatchedTrxLogsFilter: action.filter,
      };

    case actions.FETCHING_ASSIGNED_APPROVERS:
      return {
        ...state,
        assignedApproversLoading: action.loading,
        assignedApprovers: null
      };

    case actions.FETCH_ASSIGNED_APPROVERS_SUCCESS:
      return {
        ...state,
        assignedApproversLoading: action.loading,
        assignedApprovers: action.result,
        assignedApproversIsError: false,
        errorMessage: action.message,
      };

    case actions.FETCH_ASSIGNED_APPROVERS_FAILED:
      return {
        ...state,
        assignedApproversLoading: action.loading,
        assignedApprovers: null,
        assignedApproversIsError: true,
        errorMessage: action.message,
      };

    case actions.MANAGING_APPROVER_DEPARTMENTS:
      return {
        ...state,
        manageApproverDepartmentsLoading: action.loading,
      };

    case actions.MANAGE_APPROVER_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        manageApproverDepartmentsLoading: action.loading,
        manageApproverDepartmentsIsError: false,
        errorMessage: action.message,
      };

    case actions.MANAGE_APPROVER_DEPARTMENTS_FAILED:
      return {
        ...state,
        manageApproverDepartmentsLoading: action.loading,
        manageApproverDepartmentsIsError: true,
        errorMessage: action.message,
      };

    case actions.FETCHING_EXCEPTION_TRX:
      return {
        ...state,
        exceptionTrxLoading: action.loading,
        exceptionTrxData: null
      };

    case actions.FETCH_EXCEPTION_TRX_SUCCESS:
      return {
        ...state,
        exceptionTrxLoading: action.loading,
        exceptionTrxData: action.result,
        exceptionTrxTotal: action.total,
        exceptionTrxSummary: action.summary,
        exceptionTrxIsError: false,
        exceptionTrxFilter: action.filter,
        exceptionTrxpagination: action.pagination,
      };

    case actions.FETCH_EXCEPTION_TRX_FAILED:
      return {
        ...state,
        exceptionLoading: action.loading,
        exceptionTrxData: null,
        exceptionTrxSummary: null,
        exceptionTrxSettings: null,
        exceptionTrxTotal: action.total,
        exceptionTrxIsError: true,
        errorMessage: action.message
      };


    case actions.UPDATING_RECON_GENERATED_REPORT_STATUS:
      return {
        ...state,
        reportFilesLoading: action.loading
      };

    case actions.UPDATE_RECON_GENERATED_REPORT_STATUS_SUCCESS: {
      const newReportFiles =
        state.reportFiles?.map(item => {
          if (item.file_name === action.payload.id) {
            item['status'] = action.payload.status;
          }
          return item;
        }) || [];

      return {
        ...state,
        reportFiles: newReportFiles,
        reportFilesLoading: false,
        isError: false,
        errorMessage: action.message
      };
    }

    case actions.UPDATE_RECON_GENERATED_REPORT_STATUS_FAILED:
      return {
        ...state,
        reportFilesLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.CHECKING_FILTERED_REMITTANCE_TRANSACTIONS:
      return {
        ...state,
        checkingFilteredRemittanceTransactionsLoading: action.loading,
        pchannelRemittanceUploadedDataLoading: action.loading
      };

    case actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        checkingFilteredRemittanceTransactionsLoading: action.loading,
        checkingFilteredRemittanceTransactionsIsError: false,
        pchannelRemittanceUploadedDataLoading: action.loading,
        remittanceActionMessage: action.message,
        remittanceActionIsError: false
      };

    case actions.CHECK_FILTERED_REMITTANCE_TRANSACTIONS_FAILED:
      return {
        ...state,
        checkingFilteredRemittanceTransactionsLoading: action.loading,
        checkingFilteredRemittanceTransactionsIsError: true,
        pchannelRemittanceUploadedDataLoading: action.loading,
        remittanceActionMessage: action.message,
        remittanceActionIsError: true
      };

    case actions.TAGGING_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET:
      return {
        ...state,
        tagFilteredRemittanceTransactionsLoading: action.loading,
        pchannelRemittanceUploadedDataLoading: true
      };

    case actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_SUCCESS:
      return {
        ...state,
        tagFilteredRemittanceTransactionsLoading: action.loading,
        tagFilteredRemittanceTransactionsIsError: false,
        pchannelRemittanceUploadedDataLoading: false,
        remittanceActionMessage: action.message,
        remittanceActionIsError: false
      };

    case actions.TAG_FILTERED_REMITTANCE_TRANSACTION_AS_OFFSET_FAILED:
      return {
        ...state,
        tagFilteredRemittanceTransactionsLoading: action.loading,
        tagFilteredRemittanceTransactionsIsError: true,
        pchannelRemittanceUploadedDataLoading: false,
        remittanceActionMessage: action.message,
        remittanceActionIsError: true
      };

    case actions.UPDATING_RECONCILIATION_REMITTANCE_STATUS:
      return {
        ...state,
        updatingReconciliationRemittanceStatus: action.loading,
        remittanceActionMessage: null
      };

    case actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_SUCCESS:
      return {
        ...state,
        updatingReconciliationRemittanceStatus: action.loading,
        updatingReconciliationRemittanceStatusIsError: false,
        remittanceActionMessage: action.message,
        remittanceActionIsError: false
      };

    case actions.UPDATE_RECONCILIATION_REMITTANCE_STATUS_FAILED:
      return {
        ...state,
        updatingReconciliationRemittanceStatus: action.loading,
        updatingReconciliationRemittanceStatusIsError: true,
        remittanceActionMessage: action.message,
        remittanceActionIsError: true
      };

    case actions.UPDATING_RESOURCE_TRANSACTION_REMITTANCE_STATUS:
      return {
        ...state,
        updateResourceTransactionRemittanceStatus: action.loading,
        remittanceActionMessage: null
      };

    case actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_SUCCESS:
      return {
        ...state,
        updateResourceTransactionRemittanceStatus: action.loading,
        updateResourceTransactionRemittanceStatusIsError: false,
        remittanceActionMessage: action.message,
        remittanceActionIsError: false
      };

    case actions.UPDATE_RESOURCE_TRANSACTION_REMITTANCE_STATUS_FAILED:
      return {
        ...state,
        updateResourceTransactionRemittanceStatus: action.loading,
        updateResourceTransactionRemittanceStatusIsError: true,
        remittanceActionMessage: action.message,
        remittanceActionIsError: true
      };

    case actions.CLEAR_REMITTANCE_MESSAGE:
      return {
        ...state,
        remittanceActionMessage: null,
        remittanceActionIsError: false
      };

    case actions.REMITTANCE_ACTIONS_NOTIFIER:
      return {
        ...state,
        remittanceActionNotifierMessage: action.message,
        remittanceActionNotifierIsSuccess: action.notifier_type
      };

    case actions.CLEAR_REMITTANCE_ACTIONS_NOTIFIER:
      return {
        ...state,
        remittanceActionNotifierMessage: null,
        remittanceActionNotifierIsSuccess: false
      };

    case actions.FETCHING_BANKS_TEMPLATE_BY_PCHANNEL:
      return {
        ...state,
        bankTemplateByPChannelLoading: action.loading,
        bankTemplateByPChannel: []
      };

    case actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_SUCCESS: {
      const channelKey = action?.payment_channel;

      return {
        ...state,
        bankTemplateByPChannelLoading: action.loading,
        remittanceActionIsError: false,
        remittanceActionMessage: action.message,
        bankTemplateByPChannel: action?.templates ?? [],
        bankTemplateByPChannelCache: channelKey
          ? {
            ...state.bankTemplateByPChannelCache,
            [channelKey]: {
              templates: action?.templates ?? []
            }
          }
          : state.bankTemplateByPChannelCache
      };
    }

    case actions.FETCH_BANK_TEMPLATE_BY_PCHANNEL_FAILED:
      return {
        ...state,
        bankTemplateByPChannelLoading: action.loading,
        remittanceActionIsError: true,
        remittanceActionMessage: action.message
      };

    case actions.EDITING_REMITTANCE_PCHANNEL_IDENTIFIER:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };

    case actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: {
      const templateId = action?.result?.id;
      const pChannelId = action?.result?.payment_channel;
      const updatedIdentifiers = action?.result?.identifiers;

      const updatedTemplateData = state.pchannelRemittanceTemplateData.map(template => {
        // only touch the matching template
        if (template.id !== templateId) return template;

        return {
          ...template,
          payment_channels: template.payment_channels.map(pc => {
            // only touch the matching payment_channel inside this template
            if (pc.payment_channel !== pChannelId) return pc;

            return {
              ...pc,
              identifiers: updatedIdentifiers
            };
          })
        };
      });

      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateData: updatedTemplateData,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: false
      };
    }

    case actions.EDIT_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true
      };

    case actions.REMOVING_REMITTANCE_PCHANNEL_IDENTIFIER:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };

    case actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: {
      const templateId = action?.result?.id;
      const removePChannelId = action?.result?.payment_channel;

      const updatedTemplateData = state.pchannelRemittanceTemplateData.map(template => {
        // only touch the matching template
        if (template.id !== templateId) return template;

        return {
          ...template,
          payment_channels: template.payment_channels.filter(
            pc => pc.payment_channel !== removePChannelId
          )
        };
      });

      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateData: updatedTemplateData,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: false
      };
    }

    case actions.REMOVE_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true
      };

    case actions.ADDING_REMITTANCE_PCHANNEL_IDENTIFIER:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading
      };

    case actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_SUCCESS: {
      const templateId = action?.result?.id;
      const pChannelId = action?.result?.payment_channel;
      const updatedIdentifiers = action?.result?.identifiers;

      const updatedTemplateData = state.pchannelRemittanceTemplateData.map(template => {
        // only touch the matching template
        if (template.id !== templateId) return template;

        const channelExists = template.payment_channels.some(
          pc => pc.payment_channel === pChannelId
        );

        const updatedPaymentChannels = channelExists
          ? // already exists: update its identifiers in place
          template.payment_channels.map(pc =>
            pc.payment_channel === pChannelId ? { ...pc, identifiers: updatedIdentifiers } : pc
          )
          : // doesn't exist yet: append a new payment_channel object
          [
            ...template.payment_channels,
            { payment_channel: pChannelId, identifiers: updatedIdentifiers }
          ];

        return {
          ...template,
          payment_channels: updatedPaymentChannels
        };
      });

      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        pchannelRemittanceTemplateData: updatedTemplateData,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: false
      };
    }

    case actions.ADD_REMITTANCE_PCHANNEL_IDENTIFIER_FAILED:
      return {
        ...state,
        pchannelRemittanceTemplateDataLoading: action.loading,
        errorMessage: action.message,
        pchannelRemittanceTemplateDataHasError: true
      };

    case actions.GENERATING_REMITTANCE_RECONCILIATION_REPORT:
      return {
        ...state,
        pageLoading: action.loading
      }

    case actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        errorMessage: action.message,
        isError: false
      }

    case actions.GENERATE_REMITTANCE_RECONCILIATION_REPORT_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.DOWNLOADING_REMITTANCE_RECONCILIATION_REPORT:
      return {
        ...state,
        pageLoading: action.loading,
        errorMessage: null,
        isError: false
      };

    case action.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.DOWNLOAD_REMITTANCE_RECONCILIATION_REPORT_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.FETCHING_GENERATED_REMITTANCE_RECONCILIATION_REPORT:
      return {
        ...state,
        generatedRemittanceReconciliationReportFileData: null,
        generatedRemittanceReconciliationReportFileDataIsLoading: action.loading
      };

    case actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_SUCCESS:
      return {
        ...state,
        generatedRemittanceReconciliationReportFileData: action.result,
        generatedRemittanceReconciliationReportFileDataIsLoading: action.loading,
        generatedRemittanceReconciliationReportFileDataIsError: false,
        generatedRemittanceReconciliationReportFileDataPagination: action.pagination,
        isError: false,
        errorMessage: action.message
      };

    case actions.FETCH_GENERATED_REMITTANCE_RECONCILIATION_REPORT_FAILED:
      return {
        ...state,
        generatedRemittanceReconciliationReportFileDataIsLoading: action.loading,
        generatedRemittanceReconciliationReportFileDataIsError: false,
        isError: true,
        errorMessage: action.message
      };

    default:
      return state;
  }
};
